/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FaqCategoryPaginateResponse } from '../../models/faq-category-paginate-response';

export interface GetFaqCategoryIndex$Params {

/**
 * Pagination offset
 */
  page?: number;

/**
 * Pagination limit
 */
  limit?: number;

/**
 * Pagination order field ascending
 */
  orderAsc?: 'id' | 'label' | 'name' | 'priority';

/**
 * Pagination order field descending
 */
  orderDesc?: 'id' | 'label' | 'name' | 'priority';

/**
 * Filter faq id
 */
  id?: number;

/**
 * Filter by content text
 */
  content?: string;

/**
 * Filter by label text
 */
  label?: string;

/**
 * Filter by name
 */
  name?: string;
}

export function getFaqCategoryIndex(http: HttpClient, rootUrl: string, params?: GetFaqCategoryIndex$Params, context?: HttpContext): Observable<StrictHttpResponse<FaqCategoryPaginateResponse>> {
  const rb = new RequestBuilder(rootUrl, getFaqCategoryIndex.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('orderAsc', params.orderAsc, {});
    rb.query('orderDesc', params.orderDesc, {});
    rb.query('id', params.id, {});
    rb.query('content', params.content, {});
    rb.query('label', params.label, {});
    rb.query('name', params.name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FaqCategoryPaginateResponse>;
    })
  );
}

getFaqCategoryIndex.PATH = '/v1/faq-category';
